import * as FC from "@fluentui/react-components";
import { useMemo } from "react";
import { ServiceRecordPanel } from "../../components/equipment/service_record_panel";
import { resolveEquipmentPermissions } from "../../services/equipment_service";
import { getCurrentUser } from "../../services/login";

const useStyles = FC.makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        ...FC.shorthands.gap("10px"),
        ...FC.shorthands.padding("10px"),
        overflow: "auto",
    },
});

/**
 * Cross-equipment maintenance and repair history.
 *
 * Creating a work order is done from a unit's detail page, because a record only exists against
 * one piece of equipment; this page reads across all of them.
 */
export const ServiceRecordList = () => {
    const styles = useStyles();
    const permissions = useMemo(() => resolveEquipmentPermissions(getCurrentUser()), []);

    return (
        <div className={styles.root}>
            <FC.Title3>维保记录</FC.Title3>
            <ServiceRecordPanel canWrite={permissions.canWrite} />
        </div>
    );
};
